module.exports = __webpack_public_path__ + "assets/images/rbyearend-05-desktop.jpg?v=6c1d22e9";